import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://05297150caf6c90b0f765ebf7af90cbf@o4507385982418944.ingest.us.sentry.io/4507685523619840",
  integrations: [
    // new CaptureConsole(),
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [
        "localhost:5137",
        /^https:\/\/api.locavibe\.com\.br/,
        /^https:\/\/assets.locavibe\.com\.br/,
      ],
    }),
    new Sentry.Replay(),
    // new Sentry.Integrations.HttpContext()
  ],
  environment: import.meta.env.VITE_APP_ENV,
  release: `backoffice@${import.meta.env.npm_package_version}`,
  // Performance Monitoring
  tracesSampleRate: 0.5, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.5, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 0.5, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
